import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import apifunctions from '../../api/functions'
import api from '../../api/api';

const EditDiaVisibilidad = ({ onSubmit }) => {
  const [dia, setDia] = useState(1)
  const [show, setShow] = useState(false);

  useEffect(() => {
    const getData = () => {
        const callback = () => {
        }

        const successCallback = (data) => {
            if (data.success){
                setDia(data.configuracion.dia)
            }
        }
        apifunctions.get(api.proyectos.cargadatos.productividad.diaVisibilidad, null, null, null, successCallback, callback, callback)
    }
    getData()
  }, [show])
  
  const toggle = () => setShow(!show);

  const enviar = () => {
    const callback = () => {
      if (onSubmit) onSubmit();
    };
    apifunctions.post(api.proyectos.cargadatos.productividad.diaVisibilidad, null, {dia: dia}, null, callback, callback, callback);
    setShow(false);
  }

  return (
    <React.Fragment>
        <Button
          id="btn-definir-dia"
          color={"secondary"}
          className="btn-sm h-100 rounded"
          onClick={() => setShow(true)}
        ><i className="fa fa-cog fa-lg"></i></Button>
        <UncontrolledTooltip target="btn-definir-dia">
          Configurar Visibilidad Productividades
        </UncontrolledTooltip>
        <Modal 
        className="ui-modal-dialog modal-primary" 
        toggle={toggle} 
        isOpen={show}
        >
          <ModalHeader toggle={toggle}>
            Configuración
          </ModalHeader>
        <ModalBody>
          <div className="ui-form">
            <section className="ui-section-block">
              <h5 className="ui-section-label">Visibilidad mensual</h5>
              <div className="ui-alert ui-alert-info">
                Definir el día de cada mes en que las productividades pasan a ser visibles.
              </div>
              <div className="ui-row-1">
                <div className="ui-field">
                  <label>Día</label>
                  <Input
                    type="number"
                    min={1}
                    max={28}
                    value={dia}
                    onChange={(e) => setDia(e.target.value)}
                  ></Input>
                </div>
              </div>
            </section>
          </div>
        </ModalBody>
        <ModalFooter>
        <Button
            onClick={enviar}
            color="success"
            >
            Confirmar
        </Button>
        <Button
            onClick={()=>setShow(false)}
            color="secondary"
            >
            Cerrar
        </Button>
        </ModalFooter>
        </Modal>
    </React.Fragment>
    )
}

export default EditDiaVisibilidad



// WEBPACK FOOTER //
// ./src/views/Imputaciones/EditDiaVisibilidad.js